"use client";

import { X, CheckCircle2, AlertCircle, Info } from "lucide-react";
import { useToastStore, type ToastVariant } from "@/lib/toast-store";
import { cn } from "@/lib/utils";

const variantStyles: Record<
  ToastVariant,
  { icon: typeof Info; className: string }
> = {
  success: {
    icon: CheckCircle2,
    className: "border-emerald-200/80 bg-emerald-50 text-emerald-950",
  },
  error: {
    icon: AlertCircle,
    className: "border-red-200/80 bg-red-50 text-red-950",
  },
  info: {
    icon: Info,
    className: "border-border/80 bg-background text-foreground",
  },
};

export function Toaster() {
  const { toasts, dismiss } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-full max-w-sm flex-col gap-2"
    >
      {toasts.map((item) => {
        const { icon: Icon, className } = variantStyles[item.variant];
        return (
          <div
            key={item.id}
            role="status"
            className={cn(
              "pointer-events-auto flex items-start gap-2 rounded-xl border px-3 py-2.5 text-sm shadow-lg",
              className
            )}
          >
            <Icon className="mt-0.5 h-4 w-4 shrink-0" />
            <p className="min-w-0 flex-1 leading-relaxed">{item.message}</p>
            <button
              type="button"
              onClick={() => dismiss(item.id)}
              className="shrink-0 rounded-sm opacity-60 transition-opacity hover:opacity-100"
              aria-label="关闭提示"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
